import { actions } from "./action-list";

export function overviewSummaryFetched(value) {
  return {
    type: actions.FETCH_OVERVIEW.FETCH_OVERVIEW_SUMMARY,
    value,
  };
}

export function financialOverviewFetched(value) {
  return {
    type: actions.FETCH_OVERVIEW.FETCH_FINANCIAL_OVERVIEW,
    value,
  };
}

export function onlineRechargeSummaryFetched(value) {
  return {
    type: actions.FETCH_OVERVIEW.FETCH_ONLINE_RECHARGE_SUMMARY,
    value,
  };
}

export function gcOverviewFetched(value) {
  return {
    type: actions.FETCH_OVERVIEW.FETCH_GC_OVERVIEW,
    value,
  };
}
